import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#041a0f] via-[#03140c] to-[#010604] text-white pt-32 pb-20 px-6 font-sans relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute bottom-0 right-10 w-[350px] h-[350px] bg-[#eddca6]/5 rounded-full filter blur-[100px] pointer-events-none"></div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <h1 className="text-4xl md:text-5xl font-serif font-black text-[#eddca6] tracking-widest mb-12 border-b border-[#eddca6]/20 pb-6">
          Refund Policy
        </h1>
        
        <div className="space-y-10 text-white/80 font-light leading-relaxed">
          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">1. Return and Exchange Policy</h2>
            <p>
              At Chirayil Gold and Diamonds, we take pride in the quality and craftsmanship of our jewellery. We understand that sometimes a piece may not meet your expectations. We offer a fair and transparent exchange policy for our valued customers.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">2. Eligibility for Returns/Exchange</h2>
            <ul className="list-disc pl-5 space-y-2 text-white/70">
              <li>Items must be returned in their original, unworn condition with all tags intact.</li>
              <li>The original invoice/receipt and authenticity certificate must be presented at the time of return.</li>
              <li>Custom-made or personalized jewellery items are not eligible for return or exchange.</li>
              <li>Returns must be initiated within 7 days of purchase.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">3. Refund Process</h2>
            <p>
              Please note that we typically do not offer cash refunds. Eligible returns will be processed as exchanges or store credit.
            </p>
            <ul className="list-disc pl-5 space-y-2 text-white/70">
              <li><strong>Exchange for Gold Jewellery:</strong> You can exchange your item for another gold ornament of equal or higher value. The exchange value will be calculated based on the current market rate of gold minus making charges and taxes of the original item.</li>
              <li><strong>Diamond Jewellery:</strong> Diamond jewellery exchanges are subject to quality checks and specific evaluation by our experts. Deductions for making charges and a standard depreciation value will apply.</li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">4. Gold Savings Scheme Refunds</h2>
            <p>
              Installments paid towards any of our Gold Savings Schemes are non-refundable in cash. Upon scheme maturity, the accumulated amount must be utilized to purchase jewellery from our showroom as per the terms of the respective scheme. Premature closure of schemes may result in forfeiture of benefits or bonuses.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl md:text-2xl font-serif text-[#eddca6] tracking-wider">5. Contact for Support</h2>
            <p>
              For any queries regarding our refund and exchange policy, please visit our showroom or contact our customer support team:
              <br />
              <strong>Phone:</strong> +91 9605155088
              <br />
              <strong>Email:</strong> info@chirayilgoldanddiamonds.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
